export default "__VITE_ASSET__BirobJN6__"